<template>
  <div class="modal fade py-1" id="mod-item-add" role="dialog">
    <div class="modal-dialog max-w-[550px] mx-auto">
      <form @submit.prevent="submit" class="modal-content p-[24px] bg-[#f8f8f8]">
        <div class="modal-header flex items-start justify-between p-0 m-0">
          <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
            {{ isEdit ? "Update Item" : "Add Items" }}
          </h4>
          <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true" @click="cancel">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body m-0 p-0">
          <div v-for="(item, index) in items" :key="item.uniqueId">
            <div class="w-full flex flex-col items-start gap-[5px]">
              <div class="w-full">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Select product</label>
                <div>
                  <Select v-model="items[index].productCode"
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] py-[12px] px-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                    @change="setProduct($event.target.value, index)" placeholder="Select a product">
                    <option value="0" selected disabled>Select a product</option>
                    <option v-for="p in getAvailableProducts(index)" :key="p.code" :value="p.code">
                      {{ p.name }}
                    </option>
                  </Select>
                  <span class="invalid-feedback" v-if="$v.items.$each[index].productCode.$error">
                    Please select a product
                  </span>
                </div>
              </div>
              <div class="w-full">
                <div v-if="
                  items[index].minimumOrderQuantity &&
                  items[index].minimumOrderQuantity > 0
                " class="w-full border" key="min-order-quantity">
                  <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">
                    Quantity
                  </label>
                  <div class="flex items-center gap-[5px] w-full">
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-[85%]"
                      :class="{
                        'is-invalid': $v.items.$each[index].quantity.$error,
                      }" type="number" readonly placeholder="Enter the quantity you needed"
                      v-model="items[index].quantity" />
                    <div class="flex items-center gap-[5px] w-[15%]">
                      <span
                        class="fa-solid fa-plus text-[16px] text-[#353535] border-[1.5px] border-solid border-[#666] rounded-full p-[5px] cursor-pointer"
                        @click="incrementQuantity(index)"></span>
                      <span
                        class="fa-solid fa-minus text-[16px] text-[#353535] border-[1.5px] border-solid border-[#666] rounded-full p-[5px] cursor-pointer"
                        :class="{
                          'cursor-not-allowed text-gray-400':
                            items[index].quantity <=
                            items[index].minimumOrderQuantity,
                        }" :disabled="items[index].quantity <=
                          items[index].minimumOrderQuantity
                          " @click="decrementQuantity(index)"></span>
                    </div>
                  </div>
                  <p>
                    This product has a minimum order quantity of
                    {{ items[index].minimumOrderQuantity }}/{{ items[index].unit }}
                  </p>
                  <p>
                    This quantity can only be increased by
                    {{ items[index].incrementalQuantity }}/{{ items[index].unit }}
                  </p>
                </div>
                <div v-else class="w-full" key="no-min-order-quantity">
                  <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">
                    Quantity
                  </label>
                  <div>
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                      :class="{
                        'is-invalid': $v.items.$each[index].quantity.$error,
                      }" type="number" placeholder="Enter quantity" v-model="items[index].quantity" />
                    <span class="invalid-feedback" v-if="$v.items.$each[index].quantity.$error">
                      min: 1
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end">
          <div class="flex items-center justify-end gap-[8px] mt-[16px] max-w-[350px] w-full">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] max-w-max w-full"
              @click="cancel" type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] max-w-max w-full disabled:cursor-not-allowed"
              type="submit" :disabled="isSubmitDisabled">
              <span v-if="isEdit">Update Item</span>
              <span v-else>Add Items</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { minValue, required } from "vuelidate/lib/validators";
import Select2 from "@/components/Select2";
export default {
  components: { Select2 },
  name: "AddItem",
  props: ["groupId", "products", "filteredProducts", "edit"],
  data() {
    return {
      items: [
        {
          productId: "",
          productCode: "",
          quantity: 0,
          price: 0,
          name: "",
          minimumOrderQuantity: 0,
          incrementalQuantity: 1,
          uniqueId: Math.floor(Math.random() * 76528752387437484) + 108,
          unit: "",
          productTax: 0,
        },
      ],
    };
  },
  created() {
    this.getAvailableProducts();
  },
  computed: {
    isEdit() {
      return this.edit !== null;
    },
    user: function () {
      return this.$store.state.currentUser;
    },
    isSubmitDisabled() {
      return this.items.some(
        (item) => item.quantity <= 0 || !item.productCode
      );
    },
    preparedProducts() {
      if (this.isEdit) {
        return this.products;
      } else {
        return this.filteredProducts;
      }
    },
  },
  validations: {
    items: {
      $each: {
        productCode: { required },
        quantity: {
          required,
          minOrderQuantity(value, parentVm) {
            const min = parentVm.minimumOrderQuantity || 0;
            return value >= min || `Minimum quantity is ${min}`;
          },
        },
      },
    },
  },
  methods: {
    getAvailableProducts(currentIndex) {
      const { sapPriceGroup } = this.user.parent;
      return this.preparedProducts.filter((product) => {
        const isActive = product.active;
        const division = product.sapDivision;
        let meetsFirstCondition = false;
        switch (sapPriceGroup) {
          case 'P1':
            meetsFirstCondition = isActive && division !== '10';
            break;
          case 'P2':
            meetsFirstCondition = isActive && division === '10';
            break;
          case 'P3':
            meetsFirstCondition = isActive;
            break;
          default:
            meetsFirstCondition = isActive;
            break;
        }
        const isNotUsedElsewhere = !this.items.some(
          (item, index) =>
            index !== currentIndex && item.productCode === product.code
        );
        return meetsFirstCondition && isNotUsedElsewhere;
      });
    },
    incrementQuantity(index) {
      this.items[index].quantity += this.items[index].incrementalQuantity;
    },
    decrementQuantity(index) {
      if (this.items[index].quantity > this.items[index].minimumOrderQuantity) {
        this.items[index].quantity -= this.items[index].incrementalQuantity;
      }
    },
    setProduct(productCode, index) {
      const selectedProduct = this.products.find(
        (product) => product.code === productCode
      );
      if (selectedProduct) {
        let item = this.items[index];
        const minimumOrderQuantity = Number(
          selectedProduct.minimumOrderQuantity || 0
        );
        const incrementalQuantity = Number(
          selectedProduct.incrementalQuantity || 1
        );
        this.$set(this.items, index, {
          uniqueId: item.uniqueId,
          productId: selectedProduct.id,
          productCode: selectedProduct.code,
          quantity: minimumOrderQuantity,
          minimumOrderQuantity: minimumOrderQuantity,
          incrementalQuantity: incrementalQuantity,
          price: 0,
          name: selectedProduct.name,
          productTax: selectedProduct.sapTaxClassification || 0,
          unit: selectedProduct.unit || "",
        });
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.isEdit) {
        this.$emit("onItemUpdated", this.items[0]);
      } else {
        this.$emit("onItemAdded", this.items[0]);
      }
      this.reset();
    },
    cancel() {
      this.reset();
    },
    reset() {
      this.items = [
        {
          productCode: "",
          productId: "",
          quantity: 0,
          price: 0,
          name: "",
          minimumOrderQuantity: 0,
          incrementalQuantity: 1,
          uniqueId: Math.floor(Math.random() * 76528752387437484) + 108,
          unit: "",
          productTax: 0,
        },
      ];
      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>
<style>
.invalid-feedback {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 0.25rem;
}
</style>